import publicKey from './agent-signing-public.json'
import type { Bindings } from './bindings'
const encoder=new TextEncoder()
const b64=(bytes:Uint8Array)=>btoa(Array.from(bytes,b=>String.fromCharCode(b)).join(''))
async function signature(env:Bindings,base:string){
 if(!env.AGENT_SIGNING_JWK)throw new Error('Agent signing key is not configured')
 const key=await crypto.subtle.importKey('jwk',JSON.parse(env.AGENT_SIGNING_JWK),{name:'Ed25519'},false,['sign'])
 return b64(new Uint8Array(await crypto.subtle.sign('Ed25519',key,encoder.encode(base))))
}
export async function signedAgentFetch(url:string,env:Bindings){
 const destination=new URL(url)
 if(destination.protocol!=='https:')throw new Error('Agent requests require HTTPS')
 const created=Math.floor(Date.now()/1000)
 const agent='"https://www.horizon-tech.io"'
 const params=`("@authority" "signature-agent");created=${created};expires=${created+60};keyid="${publicKey.kid}";alg="ed25519";nonce="${crypto.randomUUID()}";tag="web-bot-auth"`
 const base=`"@authority": ${destination.host}\n"signature-agent": ${agent}\n"@signature-params": ${params}`
 const response=await fetch(destination,{redirect:'manual',signal:AbortSignal.timeout(10000),headers:{
  'Signature-Agent':agent,'Signature-Input':`sig1=${params}`,'Signature':`sig1=:${await signature(env,base)}:`,
  'User-Agent':'HorizonTech-Research/1.0 (+https://www.horizon-tech.io/auth.md)',
 }})
 if(response.status>=300&&response.status<400)throw new Error('Signed agent request cannot follow redirects')
 return response
}
export async function signingDirectory(request:Request,env:Bindings){
 try{
  const created=Math.floor(Date.now()/1000)
  const params=`("@authority";req);created=${created};expires=${created+300};keyid="${publicKey.kid}";alg="ed25519";nonce="${crypto.randomUUID()}";tag="http-message-signatures-directory"`
  const base=`"@authority";req: ${new URL(request.url).host}\n"@signature-params": ${params}`
  return new Response(JSON.stringify({keys:[publicKey]}),{headers:{'Content-Type':'application/http-message-signatures-directory+json','Cache-Control':'public, max-age=60','Signature-Input':`sig1=${params}`,'Signature':`sig1=:${await signature(env,base)}:`,'Access-Control-Allow-Origin':'*'}})
 }catch{return Response.json({error:'Signing directory temporarily unavailable'},{status:503,headers:{'Cache-Control':'no-store'}})}
}
